module.exports = __webpack_public_path__ + "static/img/103.7c22321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/103.png
// module id = lHQk
// module chunks = 0